import PropTypes from 'prop-types';
import React from 'react';

import CustomModal from '../CustomModal';

const SimInstructionsModal = ({ modal, onHide }) => {
  return (
    <CustomModal modal={modal} onHide={onHide} size="lg">
      <CustomModal.Header onHide={onHide}>Select Active SIM</CustomModal.Header>
      <CustomModal.Body>
        <div className="pb-4">
          For cellular WAN connectivity, you can switch between the built-in KVH
          Global SIM or your own third-party SIM. To use your own SIM, follow
          these steps:
        </div>
        <div className="pb-4">
          <strong>Important!</strong> Before you can use your own SIM card, it
          must be activated to pair with the TracNet system’s TCM. Contact your
          cell carrier. You may need the TCM’s IMEI number, located on the
          Support page, to activate.{' '}
          <em>
            Note that not all cell carriers currently support the TCM device on
            their network.
          </em>
        </div>
        <div className="pb-4">
          <ol type="1" className="pl-4 mb-0">
            <li className="pb-1">
              For the desired BDU SIM card slot, enter or verify your SIM&apos;s
              carrier APN. (You may also assign a friendly name to this SIM.)
            </li>
            <li className="pb-1">Select that BDU SIM as the Active SIM.</li>
            <li>
              When prompted:
              <ul className="pl-4 pr-2">
                <li className="pb-1">
                  Choose <strong>Activate SIM &amp; Power Off</strong> if you
                  still need to install the SIM card in the BDU. (Next, install
                  your SIM card in the selected BDU SIM card slot. Then power on
                  the system.)
                </li>
                <li className="pb-1">
                  Choose <strong>Activate SIM &amp; Restart</strong> if the SIM
                  card is already installed in the BDU.
                </li>
              </ul>
            </li>
            <li>
              Following system restart, the selected SIM will be active. Return
              to this WAN Settings page to check its service connection and
              verify the SIM card&apos;s information (e.g., ICCID and IMSI).
            </li>
          </ol>
        </div>
        <div className="pb-4">
          To revert to using the KVH Global SIM, simply select it as the Active
          SIM and restart.
        </div>
      </CustomModal.Body>
    </CustomModal>
  );
};

SimInstructionsModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default SimInstructionsModal;
